module.exports = __webpack_public_path__ + "static/media/pic3.bae810a9.jpg";